import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '#/components/ui/dialog';

import { DATA_AREAS } from '~/constants/data-areas';

import { SvgIconChatbot } from '../svg/icon-chatbot';
import { SvgIconClose } from '../svg/icon-close';

export const SiteChatBot = () => {
  return (
    <div data-area={DATA_AREAS.SITE_CHATBOT}>
      <Dialog>
        <DialogTrigger asChild>
          <button
            type="button"
            aria-label="サポートデスク"
            className="fixed right-4 bottom-4 z-40 -translate-y-1/2 rounded-full md:right-6 md:bottom-8">
            <SvgIconChatbot width={48} height={48} />
          </button>
        </DialogTrigger>
        <DialogContent
          className={
            'text-body-s flex max-h-[calc(100svh-5rem)] w-[calc(100vw-2rem)] max-w-screen-md flex-col gap-0 overflow-hidden rounded-2xl bg-white px-1 pt-4 pb-0'
          }>
          <DialogHeader className="mb-3 flex justify-between px-4">
            <DialogTitle className="text-caption-m-bold md:text-headline-s lg:text-headline-s">
              KABU&カブ活 チャットサポート
            </DialogTitle>
            <DialogDescription className="sr-only">KABU&カブ活 チャットサポート</DialogDescription>
            <DialogClose asChild>
              <button type="button" aria-label="Close">
                <SvgIconClose width={24} height={24} />
              </button>
            </DialogClose>
          </DialogHeader>

          <div className="flex flex-col gap-6 overflow-y-scroll px-0">
            <iframe
              src={`${import.meta.env.VITE_APP_KABUAND_CHATBOT_URL}`}
              width="100%"
              height="512"
              className="w-full"
              title="chatbot"
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
